module.exports = __webpack_public_path__ + "static/media/checkbox_small_x.98ddcd27.svg";